import { Component, Input, Output, EventEmitter, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { ProjectItemComponent } from './project-item.component';
import { ProjectItemWithSelectionComponent } from "./project-item-withselection.component";
import { GenericValidator } from '../shared/generic-validator';
import { Observable } from 'rxjs/Observable';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
    selector: 'production-contact',
    template: require('./production-contact.component.html')
})
export class ProductionContactComponent extends ProjectItemWithSelectionComponent {// implements AfterViewInit {
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    displayMessage: { [key: string]: string } = {};

    constructor() {
        super();
        this.validationMessages = {
            email: {
                pattern: 'Please Enter a valid Email.'
            },
            name: {
                // required: 'Please Enter the Name.',
                maxlength: 'Contact Name Cannot be Longer than 80 Characters'
            }
        }
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    ngAfterViewInit() {
        
        //Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));
    
        //Merge the blur event observable with the valueChanges observable
        Observable.merge(this.projectItemForm.valueChanges, ...controlBlurs)
        .debounceTime(500)
        .subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.projectItemForm);
        });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/production-contact.component.ts